import { render, staticRenderFns } from "./bi-file.vue?vue&type=template&id=a632325c&"
import script from "./bi-file.vue?vue&type=script&lang=ts&"
export * from "./bi-file.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports